import { tv } from "tailwind-variants";

/**
 * Tailwind variants for badge grouping/positioning within CpBadgeWrapper
 * Handles border radius removal and overlapping for connected badge appearance
 */
export const CpBadgeGroupVariants = tv({
  base: "",
  variants: {
    direction: {
      row: "",
      column: "w-full", // All badges full width when stacked vertically
    },
    position: {
      first: "",
      middle: "",
      last: "",
      only: "", // Single badge - no modifications needed
    },
  },
  compoundVariants: [
    // Row direction (horizontal) compounds
    {
      direction: "row",
      position: "first",
      class: [
        // Remove right border radius for first badge in row
        "rounded-r-none",
        // Fix hover overlay border radius for button badges
        "after:rounded-r-none",
      ],
    },
    {
      direction: "row",
      position: "middle",
      class: [
        // Remove both left and right border radius for middle badges
        "rounded-l-none rounded-r-none",
        // Overlap left border by moving left
        "-ml-px",
        // Fix hover overlay border radius for button badges
        "after:rounded-l-none after:rounded-r-none",
      ],
    },
    {
      direction: "row",
      position: "last",
      class: [
        // Remove left border radius for last badge in row
        "rounded-l-none",
        // Overlap left border by moving left
        "-ml-px",
        // Fix hover overlay border radius for button badges
        "after:rounded-l-none",
      ],
    },
    // Column direction (vertical) compounds
    {
      direction: "column",
      position: "first",
      class: [
        // Remove bottom border radius for first badge in column
        "rounded-b-none",
        // Fix hover overlay border radius for button badges
        "after:rounded-b-none",
      ],
    },
    {
      direction: "column",
      position: "middle",
      class: [
        // Remove both top and bottom border radius for middle badges
        "rounded-t-none rounded-b-none",
        // Overlap top border by moving up
        "-mt-px",
        // Fix hover overlay border radius for button badges
        "after:rounded-t-none after:rounded-b-none",
      ],
    },
    {
      direction: "column",
      position: "last",
      class: [
        // Remove top border radius for last badge in column
        "rounded-t-none",
        // Overlap top border by moving up
        "-mt-px",
        // Fix hover overlay border radius for button badges
        "after:rounded-t-none",
      ],
    },
  ],
});
